if (!customElements.get("navigation-slider")) {
  customElements.define(
    "navigation-slider",
    class NavigationSlider extends HTMLElement {
      constructor() {
        super();
        this.navigationLinks = Array.from(this.querySelectorAll("a[data-menu]"));
        this.headerDrawer = document.querySelector('#Details-menu-drawer-container');
        this.headerDrawerSummary = this.headerDrawer.querySelector('summary');
        this.bindEvents();
      }

      bindEvents() {
        this.navigationLinks.forEach(link => {
          link.addEventListener("click", this.onLinkClick.bind(this));
        });
      }

      onLinkClick(event) {
        event.preventDefault();
        const menuId = event.currentTarget.dataset.menu;
        this.headerDrawerSummary.click();
        const childSummary = this.headerDrawer.querySelector(`#Details-menu-drawer-child-summary-${menuId}`);
        if (childSummary) {
          childSummary.click();
        }
      }
    }
  );
}